import React, {useState} from 'react'
import CheckoutSteps from './CheckoutSteps';
import {useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {savePaymentMethod} from '../redux/cart/cartActions';

const CheckoutPayment = () => {
  const history = useHistory();
  const {paymentMethod} = useSelector(state => state.cart)
  const {userInfo} = useSelector(state => state.userLogin)

  const dispatch = useDispatch()

  const [paymentMethodChanges, setPaymentMethodChanges] = useState(paymentMethod);

  if(!userInfo) {
    history.push('/login')
  }
  
  const handleSubmit = (e) =>{
    e.preventDefault();
    console.log(paymentMethodChanges);
    dispatch(savePaymentMethod(paymentMethodChanges))
    history.push('/checkout/confirm')
  }

  return (
    <div className="pageContainer">
      
      <CheckoutSteps step1 step2 step3/>

        <div className="pageHeader">
            <p>Payment Method</p>
        </div>

        <div className="pageBody">
          <form onSubmit={handleSubmit}>
            <div>
              <label>Select Method</label>
              <div onChange={(e) => setPaymentMethodChanges(e.target.value)}>
                <input type='radio' value='Paypal' name="paymentMethodChanges"/>PayPal
                <br/>
                <input type='radio' value='Stripe' name="paymentMethodChanges"/>Stripe
              </div>
            </div>

            <button type="submit">Continue</button>
          </form>
        </div>
    </div>
  )
}

export default CheckoutPayment